import { createIcon } from '../../createIcon';
import { withIcon } from '../../withIcon';
import { BookSvg } from './Book';

export const BookIcon = createIcon('book', BookSvg);
/**
 * @deprecated используйте BookIcon
 */
export const withBookIcon = withIcon('book', BookSvg);
